import { yupResolver } from "@hookform/resolvers/yup";
import { PostDownloadCategory, PostDownloads, UploadFile } from "api/endpoints";
import FilePreviewer from "components/ckeditor/MEIFilePreview";
import MEILoader from "components/ckeditor/MEILoader";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";

import { Card, FloatingLabel, } from "react-bootstrap";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { FiUpload } from "react-icons/fi";
import { toast } from "react-toastify";
import * as yup from "yup";
// import ProductBasicInfo from "./add-product-tab/ProductBasicInfo";

const schema = yup
    .object({
        fTitle: yup.string().required("Title is required."),
        fStatus: yup.string().required("Status is required."),
        fIcon: yup.string(),
        fOrder: yup.number().required("Sequence is required.").min(0, 'Please enter valid number'),
        fFile: yup.string(),
    })
    .required();

const initialForm = {
    fTitle: '',
    fFile: '',
    fStatus: 'true',
    fIcon: '',
    fOrder: '0',

};

const ProductBasicInfo = ({setLoading}) => {
    const {
        register,
        formState: { errors },
        setValue,
        watch
    } = useFormContext();



    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {

            const allowedTypes = [
                'image/jpeg', // .jpg, .jpeg
                'image/png',  // .png
            ];
            if (!allowedTypes.includes(file.type)) {
                toast.error('Invalid File Format', {
                    theme: "colored",
                });
                e.target.value = '';
                return
            }
            else {
                setLoading(true)
                const formData = new FormData();
                formData.append('file', file);

                UploadFile(formData).then(res => {
                    // toast.success('File Uploaded Successfully!', {
                    //   theme: "colored",
                    // });
                    setValue('fFile', res?.data)
                    e.target.value = '';
                    setLoading(false)

                }).catch(err => {
                    setLoading(false)
                    toast.error('File Uploading Failed', {
                        theme: "colored",
                    });
                });
            }

        }
    };

    return (
        <Row className="gx-2 gy-3">

            <Col md="12">
                <Form.Group>
                    {/* <Form.Label>First name:</Form.Label> */}
                    <FloatingLabel
                        controlId="floatingInput"
                        label="Title"
                        className=""
                    >
                        <Form.Control
                            type="text"
                            placeholder=""
                            isInvalid={!!errors.fTitle}
                            {...register("fTitle")}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.fTitle?.message}
                        </Form.Control.Feedback>
                    </FloatingLabel>
                </Form.Group>
            </Col>


            <Col md="6" style={{ position: 'relative' }}>

                <Form.Label style={{ left: 10, position: 'absolute', top: 0 }}>
                    Profile Image (30 x 30)
                </Form.Label>
                <FilePreviewer accept=" .jpg, .jpeg, .png" furl={watch('fFile')} />


                <Form.Label htmlFor={`file-upload-dc`} style={{ position: 'absolute', zIndex: 99, right: 20, top: '20%', cursor: 'pointer', textDecoration: 'underline' }} className="text-info">
                    <FiUpload className="me-1" size={40} />
                </Form.Label>

                <Form.Control
                    id={`file-upload-dc`}
                    type="file"
                    style={{ width: '120px' }}
                    onChange={(e) => handleFileChange(e)}
                    className="d-none"
                    accept=" .jpg, .jpeg, .png"
                />

            </Col>


            <Col md="4">
                <Form.Group>
                    <FloatingLabel controlId="floatingInput" label="Status" className="">
                        <Form.Control
                            as="select"
                            placeholder=""
                            isInvalid={!!errors.fStatus}
                            {...register("fStatus")}
                        >
                            <option value="true">Published</option>
                            <option value="false">Un-Published</option>

                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                            {errors.fStatus?.message}
                        </Form.Control.Feedback>
                    </FloatingLabel>
                </Form.Group>
            </Col>


            {/* <Col md="4">
                <Form.Group>
                    <FloatingLabel controlId="floatingInput" label="Icon" className="">
                        <Form.Control
                            type="number"
                            placeholder=""
                            isInvalid={!!errors.fIcon}
                            {...register("fIcon")}
                        >

                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                            {errors.fIcon?.message}
                        </Form.Control.Feedback>
                    </FloatingLabel>
                </Form.Group>
            </Col> */}


            <Col md="4">
                <Form.Group>
                    <FloatingLabel controlId="floatingInput" label="Sequence Order" className="">
                        <Form.Control
                            type="number"
                            placeholder=""
                            isInvalid={!!errors.fOrder}
                            {...register("fOrder")}
                        >

                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                            {errors.fOrder?.message}
                        </Form.Control.Feedback>
                    </FloatingLabel>
                </Form.Group>
            </Col>

        </Row>
    );
};


const AddCategory = ({ handleDiscard, editData }) => {
    const submittedValues = {};
    const methods = useForm({
        resolver: yupResolver(schema),
        defaultValues: {},
    });
    const { handleSubmit, reset } = methods;

    useEffect(() => {
        if (editData?.id) {
            reset({
                fTitle: editData.name,
                fStatus: editData.status.toString(),
                fIcon: editData.icons,
                fOrder: editData.sortOrder,

                fFile: editData.logo,
            })
        }
        else {
            reset(initialForm);
        }

    }, [editData])

    const [loading, setLoading] = useState(false);

    const onSubmit = (data) => {
        console.log(data);
        // // ------- Get all object keys form data and set empty values to reset ------------
        // const keys = Object.keys(data);
        // for (const key of keys) {
        //   submittedValues[key] = "";
        // }

        setLoading(true)
        const finalData = {
            id: editData?.id ? editData?.id : 0,
            name: data.fTitle,
            icons: data.fIcon,
            status: data.fStatus === "true",
            sortOrder: data.fOrder,

            description: "",
            logo: data.fFile,
            parent: 0,
            cLevel: 0,
            isPopular: true,
            isHot: true,
            isNew: true,
            url: ""
        }

        PostDownloadCategory(finalData).then(res => {

            toast.success('Data Saved Successfully', {
                theme: "colored",
            });
            setLoading(false)
            reset(initialForm)
            handleDiscard(true);

        }).catch(err => {

            toast.error('Data Saving Failed', {
                theme: "colored",
            });
            setLoading(false)
            console.log(err, 'PostDownloadsError')

        });


    };

    const handleDiscardPre = () => {
        reset(initialForm)
        handleDiscard();
    }

    return (
        <>

            <MEILoader showLoader={loading} />
            <FormProvider {...methods}>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="g-3">

                        <Col lg={12}>
                            <ProductBasicInfo setLoading={setLoading} />
                        </Col>

                        <Col xs={12}>
                            <Row className="flex-between-center mt-3">
                                <Col md>
                                    {/* <h5 className="mb-2 mb-md-0">You're almost done</h5> */}
                                </Col>
                                <Col xs="auto">
                                    <Button
                                        variant="link"
                                        className="text-secondary fw-medium p-0 me-3"
                                        type="button"
                                        onClick={handleDiscardPre}
                                    >
                                        Discard
                                    </Button>
                                    <Button variant="primary" type="submit" disabled={loading}>
                                        {editData?.id ? 'Update' : 'Add'}
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>
            </FormProvider>
        </>
    );
};

export default AddCategory;
